import { type FC } from 'react';
import ArrowTopIcon from '@assets/img/icons/arrow-top.svg?react';
import cn from 'classnames';

import { StringXSmall } from '../Typography/Typography';
import { LinkButton } from '../ui/Button/Button';
import { Container } from '../ui/Container/container';
import { DotAnimation } from '../ui/DotAnimation/DotAnimation';

interface ToUpgradeProps {
  link: string;
  isComplete: boolean;
}

const ToUpgrade: FC<ToUpgradeProps> = ({ link, isComplete }) => {
  return (
    <LinkButton
      to={link}
      className="!w-12 !h-12 shrink-0"
      variant="transparent"
      state={{ isUpgraded: true }}
    >
      <Container
        className="w-full h-full gap-[2px] flex flex-col items-center justify-center relative !rounded-full"
        variant="circle-button"
      >
        {isComplete && <DotAnimation className="absolute top-1 right-1" />}
        <ArrowTopIcon className={cn('w-6 h-6 shink-0 text-accent')} />
        <StringXSmall weight="bold">Level</StringXSmall>
      </Container>
    </LinkButton>
  );
};

export { ToUpgrade };
